import { DefaultContext } from '@apollo/client';

export type WithApolloContext = {
  context: DefaultContext;
};

export const telemetryContextFor = <P>(component: React.ComponentType<P>) => ({
  telemetry: {
    component: component.displayName ?? 'unknown',
  },
});
